import React from "react";
import { NavLink } from "react-router-dom";
import logo from "../Images/logo.png";

function Navbar() {
  // Function to close the menu
  const handleNavLinkClick = () => {
    const navbarToggler = document.querySelector(".navbar-toggler");
    const navbarCollapse = document.querySelector("#navbarNav");

    if (navbarCollapse.classList.contains("show")) {
      navbarToggler.click(); // programmatically toggle
    }
  };
  return (
    <nav className="navbar navbar-expand-lg bg-white shadow-sm py-3" style={{ minHeight: "80px" }}>
      <div className="container d-flex align-items-center">
        {/* Logo */}
        <NavLink to="/" className="navbar-brand">
          <img src={logo} alt="Logo" className="img-fluid" style={{ height: "70px" }} />
        </NavLink>

        {/* Toggle button for mobile */}
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navbar Links */}
        <div className="collapse navbar-collapse justify-content-end " id="navbarNav">
          <ul className="navbar-nav  gap-4">
            <li className="nav-item">
              <NavLink to="/"  onClick={handleNavLinkClick} className="nav-link fs-4 text-navyblue" activeClassName="active">
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/about" onClick={handleNavLinkClick} className="nav-link fs-4 text-navyblue" activeClassName="active">
                About
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/services" onClick={handleNavLinkClick} className="nav-link fs-4 text-navyblue" activeClassName="active">
                Services
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/contact" onClick={handleNavLinkClick} className="nav-link fs-4 text-navyblue" activeClassName="active">
                Contact
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
export default Navbar;